<template>
  <header class="scio-workspace-page-header">
    <div class="scio-workspace-page-header-main">
      <div class="scio-workspace-page-header-identity">
        <div class="scio-workspace-page-header-meta">
          <span v-if="eyebrow" class="scio-workspace-page-eyebrow">{{ eyebrow }}</span>
          <slot name="status" />
        </div>

      <div class="scio-workspace-page-title-row">
        <h1 class="scio-workspace-page-title" :title="titleTooltip || title"><slot name="title">{{ title }}</slot></h1>
        <div v-if="$slots.context" class="scio-workspace-page-context">
          <slot name="context" />
        </div>
      </div>
      <div v-if="$slots.subtitle" class="scio-page-subtitle">
        <slot name="subtitle" />
      </div>
      </div>

      <div v-if="$slots.actions" class="scio-se-header-actions scio-workspace-page-actions">
        <slot name="actions" />
      </div>
    </div>

    <div v-if="$slots.toolbar" class="scio-workspace-page-toolbar">
      <slot name="toolbar" />
    </div>
  </header>
</template>

<script>
export default {
  name: "WorkspacePageHeader",
  props: {
    eyebrow: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    titleTooltip: {
      type: String,
      default: "",
    },
  },
};
</script>
